<login-home-navigation></login-home-navigation>

<!-- HERO -->

<section class="vendor-hero">

    <div class="container">

        <span class="page-badge">
            Vendor Benefits
        </span>

        <h1>
            Get More RFQs Without Increasing Your Sales & Marketing Costs
        </h1>

        <p>
            Connect with buyers actively searching for machining,
            casting, forging, fabrication, molding and manufacturing suppliers.
        </p>

        <a routerLink="/login/signup" class="primary-btn">
            Register Your Company
        </a>

    </div>

</section>

<!-- TRUST NUMBERS -->

<section class="vendor-stats">

    <div class="container">

        <div class="stats-grid">

            <div class="stat-item">
                <h3>300+</h3>
                <span>Active Buyers</span>
            </div>

            <div class="stat-item">
                <h3>16,000+</h3>
                <span>Suppliers</span>
            </div>

            <div class="stat-item">
                <h3>3,000+</h3>
                <span>Business Matches</span>
            </div>

            <div class="stat-item">
                <h3>40+</h3>
                <span>Manufacturing Categories</span>
            </div>

        </div>

    </div>

</section>

<!-- ROI -->

<section class="roi-section">

    <div class="container">

        <div class="section-header">

            <h2>
                Reduce Customer Acquisition Cost
            </h2>

            <p>
                Traditional business development requires travel,
                exhibitions, sales visits and cold calling.
            </p>

        </div>

        <div class="row">

            <div class="col-lg-6">

                <div class="roi-card negative">

                    <h3>Traditional Sales Approach</h3>

                    <ul>
                        <li>Travel to customer locations</li>
                        <li>Cold calling and follow-ups</li>
                        <li>Trade shows and exhibitions</li>
                        <li>Higher sales team expenses</li>
                        <li>Long buyer identification cycles</li>
                    </ul>

                </div>

            </div>

            <div class="col-lg-6">

                <div class="roi-card positive">

                    <h3>With GYV</h3>

                    <ul>
                        <li>Access sourcing opportunities online</li>
                        <li>Connect with procurement teams</li>
                        <li>Receive relevant RFQ visibility</li>
                        <li>Reduce travel and prospecting effort</li>
                        <li>Focus on manufacturing, not searching</li>
                    </ul>

                </div>

            </div>

        </div>

    </div>

</section>

<!-- BENEFITS -->

<section class="vendor-benefits">

    <div class="container">

        <div class="section-header">

            <h2>
                Why Manufacturers Join GYV
            </h2>

        </div>

        <div class="row">

            <div class="col-lg-3 col-md-6">

                <div class="benefit-card">

                    <i class="fa fa-users"></i>

                    <h4>Buyer Access</h4>

                    <p>
                        Connect with sourcing and procurement teams.
                    </p>

                </div>

            </div>

            <div class="col-lg-3 col-md-6">

                <div class="benefit-card">

                    <i class="fa fa-file-text"></i>

                    <h4>RFQ Visibility</h4>

                    <p>
                        View relevant sourcing opportunities.
                    </p>

                </div>

            </div>

            <div class="col-lg-3 col-md-6">

                <div class="benefit-card">

                    <i class="fa fa-industry"></i>

                    <h4>Showcase Capabilities</h4>

                    <p>
                        Present your manufacturing strengths.
                    </p>

                </div>

            </div>

            <div class="col-lg-3 col-md-6">

                <div class="benefit-card">

                    <i class="fa fa-line-chart"></i>

                    <h4>Business Growth</h4>

                    <p>
                        Expand beyond your existing customer base.
                    </p>

                </div>

            </div>

        </div>

    </div>

</section>

<!-- WHAT YOU GET -->

<section class="features-section">

    <div class="container">

        <div class="section-header">

            <h2>What You Get On GYV</h2>

        </div>

        <div class="row">

            <div class="col-lg-6">

                <ul class="feature-list">
                    <li>Buyer Discovery</li>
                    <li>RFQ Access</li>
                    <li>Digital Company Profile</li>
                    <li>Manufacturing Category Listing</li>
                    <li>Direct Buyer Interaction</li>
                </ul>

            </div>

            <div class="col-lg-6">

                <ul class="feature-list">
                    <li>Quotation Submission</li>
                    <li>Lead Management</li>
                    <li>Business Opportunity Alerts</li>
                    <li>Buyer Background Information</li>
                    <li>Technical Support</li>
                </ul>

            </div>

        </div>

    </div>

</section>

<!-- CTA -->

<section class="vendor-cta">

    <div class="container">

        <h2>
            Ready To Connect With More Buyers?
        </h2>

        <p>
            Join India's growing manufacturing supplier network.
        </p>

        <a routerLink="/login/signup" class="primary-btn">
            Register Your Company
        </a>

    </div>

</section>

<login-home-footer></login-home-footer>